import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Card, CardGroup, Row, Col } from 'react-bootstrap'
import { TextInput, FileUploader, TextArea } from 'carbon-components-react';
import Select from 'react-select';
import SelectLabel from '../../../components/SelectLabel';
import HyperLinkButtonArray from './detailConneX/HyperLinkButtonArray';
// styles
import {
  selectStyles,
  getSelectValuesToSubmit,
  getValuesForReactSelect,
} from '../../../helpers/formUtils'
// api
import { getSimpleStudyList } from '../../../api/studyListApi'
import HyperLinkButtonSingle from './detailConneX/HyperLinkButtonSingle';
import { getCommercialProducts } from '../../../api/commercialProducts';
import { getDevelopmentStatuss } from '../../../api/developmentStatuss';
const hyperlinkButtonsFields = [
  {
    id: "button_text",
    labelText: "Button Text",
    type: "textInput",
    rows: 1,
  },
  {
    id: "link",
    labelText: "Link",
    type: "textInput",
  },
]

const DetailManual = ({
  data,
  dirtyFields,
  dataToSubmit,
  setDataToSubmit,
  SET_SPONSOR_DATA,
  SET_RELATED_STUDIES,
  SET_COMMERCIAL_PRODUCTS,
  SET_DEVELOPMENT_STATUS,
  fieldStatuses,
}) => {

  const [commercialProducts, setCommercialProducts] = useState(null)
  const [developmentStatuses, setDevelopmentStatuses] = useState(null)
  const [relatedStudies, setRelatedStudies] = useState(null)
  const [relatedStudyOptions, setRelatedStudyOptions] = useState(null)
  const [logoSrc, setLogoSrc] = useState(null)
  const placeboItems = [
    { value: "1", label: "Yes" },
    { value: "2", label: "No" },
  ]


  const commercialProductOptions = commercialProducts?.map((element) => ({
    value: String(element.id),
    label: element.name
  }))

  const developmentStatusOptions = developmentStatuses?.map((element) => ({
    value: String(element.id),
    label: element.name
  }))

  const logoFilenameStatus = () => {
    if (fieldStatuses?.sponsor_data?.logo) {
      if (fieldStatuses.sponsor_data.logo === 'pending') {
        return 'uploading'
      } else if (fieldStatuses.sponsor_data.logo === 'resolved') {
        return 'complete'
      }
    }
    return 'edit'
  }

  useEffect(() => {
    getSimpleStudyList().then((res) => {
      setRelatedStudies(res)
      const options = res.reduce((acc, study) => {
        // exclude this study
        if (Number(study.id) !== Number(data.id)) acc.push({
          value: study.id, label: study.org_study_id,
        });
        return acc
      }, [])
      setRelatedStudyOptions(options)
    })
    getCommercialProducts().then((res) => {
      setCommercialProducts(res.map(element => ({
        id: String(element.id),
        name: element.name,
        additional_info: element.additional_info
      })))
    })
    getDevelopmentStatuss().then((res) => {
      setDevelopmentStatuses(res.map(element => ({
        id: String(element.id),
        name: element.name,
        additional_info: element.additional_info
      })))
    })
  }, [])

  useEffect(() => {
    if (data?.logo) setLogoSrc(data.logo);
  }, [data?.logo])


  /** EVENT HANDLERS */

  const onTextFieldChange = (evt) => {
    const name = evt.target.id
    let value = evt.target.value
    setDataToSubmit({ type: SET_SPONSOR_DATA, name, value })
  }

  const onSelectChange = (selectedItems, evtObject) => {
    const name = evtObject.name
    let value = null
    if (name === 'related_studies') {
      value = selectedItems?.map((select) => {
        return relatedStudies?.find((study) => study.id === select.value)
      })
      setDataToSubmit({ type: SET_RELATED_STUDIES, name, value })
    } else if (name === 'possibility_of_active_intervention') {
      value = getSelectValuesToSubmit(selectedItems, evtObject)
      setDataToSubmit({ type: SET_SPONSOR_DATA, name, value })
    } else if (name === "commercial_products") {
      value = selectedItems?.map((select) => {
        return commercialProducts?.find((element) => element?.id === select.value)
      })
      setDataToSubmit({ type: SET_COMMERCIAL_PRODUCTS, name, value })
    } else if (name === "development_status") {
      value = developmentStatuses?.find((element) => element?.id === selectedItems.value)
      setDataToSubmit({ type: SET_DEVELOPMENT_STATUS, name, value })
    }
  }

  const onLogoUpload = async (evt) => {
    const value = evt.target.files[0]

    // preview image
    const reader = new FileReader()
    const url = reader.readAsDataURL(value)
    reader.onloadend = (evt) => {
      setLogoSrc([reader.result])
    }

    setDataToSubmit({
      name: evt.target.name,
      value,
    }) // type: "LOGO"?
  }

  const onLogoDelete = (evt) => {
    setLogoSrc(data?.logo)
  }

  const onLogoRemove = (evt) => {
    setLogoSrc(null);
    setDataToSubmit({
      name: 'logo',
      value: 'remove',
    })
  }
  /** RENDERERS */

  const getTextField = (id, label) => {
    return <TextFieldStyled
      isDirty={dirtyFields?.sponsor_data?.[id]}
    >
      <TextInput
        id={id}
        labelText={label}
        size="sm"
        defaultValue={data?.sponsor_data?.[id]}
        onChange={onTextFieldChange}
      />
    </TextFieldStyled>
  }
  const getTextAreaField = (id, label) => {
    return <TextFieldStyled
      isDirty={dirtyFields?.sponsor_data?.[id]}
    >
      <TextArea
        id={id}
        labelText={label}
        size="sm"
        defaultValue={data?.sponsor_data?.[id]}
        onChange={onTextFieldChange}
      />
    </TextFieldStyled>
  }
  // TODO: For Button Text Array
  // const getFieldGroupArray = (id, title, fields) => {
  // 	const origData = data?.sponsor_data?.[id]
  //   const submitData = dataToSubmit?.sponsor_data?.[id]
  // 	const isDirty = dirtyFields?.sponsor_data?.[id]
  // 	return <OverrideCardStyled>
  // 		<Row className="mb-4">
  //       <Col>
  // 				<SelectLabel
  // 					id={id}
  // 				>{title}</SelectLabel>
  //           <HyperLinkButtonArray 
  //             id={id}
  //             fieldMap={fields}
  //             sourceData={origData}
  // 						submitData={submitData}
  //             setDataToSubmit={setDataToSubmit}
  //             isDirty={isDirty}
  //             label={title}

  //           />
  //     </Col>
  // 		</Row>
  // 	</OverrideCardStyled>

  // }

  const getSelectField = (id, label, options, isMulti = false) => {
    
    const getValuesforRelatedStudySelect = (values) => {
      return values?.map((study) => ({
        value: study.id, label: study.org_study_id,
      }))
    }

    const getValuesforCommercialProductSelect = (values) => {
      return values?.map((element) => ({
        value: element.id, label: element.name,
      }))
    }

    const getValuesForDevelopmentStatusSelect = (values) => {
      return  {
        value: values?.id, 
        label: values?.name
      }
    }

    let defaultValue = null
    let dirtyValue = null
    if (id === 'related_studies') {
      defaultValue = getValuesforRelatedStudySelect(data?.related_studies)
      dirtyValue = dirtyFields?.related_studies
    } else if (id === 'possibility_of_active_intervention') {
      defaultValue = getValuesForReactSelect(data?.sponsor_data?.[id], options)
      dirtyValue = dirtyFields?.sponsor_data?.[id]
    } else if (id === "commercial_products") {
      defaultValue = getValuesforCommercialProductSelect(data?.commercial_products)
      dirtyValue = dirtyFields?.commercial_products
    }
    else if (id === "development_status") {
      defaultValue = getValuesForDevelopmentStatusSelect(data?.development_status)
      dirtyValue = dirtyFields?.development_status
    }
    return <>
      <SelectLabel
        id={`manual-data-${id}`}
        htmlFor={`manual-data-${id}`}
      >
        {label}
      </SelectLabel>
      <Select
        name={id}
        aria-labelledby={`manual-data-${id}`}
        defaultValue={defaultValue}
        options={options}
        isMulti={isMulti}
        onChange={onSelectChange}
        styles={selectStyles({ isDirty: dirtyValue })}
      />
    </>
  }

  return (
    <ManualWrapper>
      <CardGroup>
        <Card>
          <Card.Body>

            <ManualPart>
              {getTextField('participation_requirements', 'Participation Requirements/Participation Duration')}
            </ManualPart>

            <ManualPart>
              {getSelectField('possibility_of_active_intervention', 'Placebo?', placeboItems)}
            </ManualPart>

            <ManualPart>
              {getTextField('vivli_search_link', 'Vivli Seach Link')}
            </ManualPart>
            <ManualPart>
                {getSelectField('development_status', 'Development Status', developmentStatusOptions, false)}
              </ManualPart>

          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <ManualPart>
                {getTextField('keyword_phrase', 'Keyword')}
              </ManualPart>

              <ManualPart>
                {getSelectField('related_studies', 'Related/Sister Studies', relatedStudyOptions, true)}
              </ManualPart>
              <ManualPart>
                {getTextField('drug_name', 'Drug Treatment Name')}
              </ManualPart>
              <ManualPart>
                {getSelectField('commercial_products', 'Commercial Products', commercialProductOptions, true)}
              </ManualPart>
{/* 
            <ManualPart>
              <FileUploadStyled
                className="bx--file__container"
                isDirty={dirtyFields?.logo}
              >
                <Row>
                  <Col>
                    <FileUploader
                      id="logo"
                      name="logo"
                      buttonKind="ghost"
                      buttonLabel="Add file"
                      iconDescription="Clear file"
                      labelTitle="Study Logo"
                      multiple={false}
                      onChange={onLogoUpload}
                      onDelete={onLogoDelete}
                      filenameStatus={logoFilenameStatus()}
                    />
                    {
                      (logoSrc && !Array.isArray(logoSrc)) &&
                      // <div onClick={onLogoRemove}>Remove</div>
                      <TrashCan>
                        <i
                          onClick={onLogoRemove}
                          className="fas fa-trash"
                        ></i>
                      </TrashCan>
                    }
                  </Col>
                  {logoSrc &&
                    <Col>
                      <img src={logoSrc} />
                    </Col>}
                </Row>
              </FileUploadStyled>
            </ManualPart> */}

            {/* <ManualPart>
              {getTextField('study_site_url', 'Study URL')}
            </ManualPart>

            <ManualPart>
              {getTextAreaField('study_site_url_comment', 'Study URL Additional Text')}
            </ManualPart> */}

            {/* <ManualPart>
              <Row className="mb-4">
                <Col>
                  <SelectLabel
                    id='hyperlink_button'
                  >Hyperlink Button</SelectLabel>
                  <HyperLinkButtonSingle
                    data={data}
                    onTextFieldChange={onTextFieldChange}
                    dirtyFields={dirtyFields}
                  />
                </Col>
              </Row>
            </ManualPart> */}
            {/* {getFieldGroupArray(
                'hyperlink_buttons',
                'HyperLink Buttons',
                hyperlinkButtonsFields,
              )} */}
          </Card.Body>
        </Card>
      </CardGroup>
    </ManualWrapper>
  );
};

export default DetailManual;

const ManualWrapper = styled.div`
  display flex;
  flex-direction: column;
  width: 100%;
`

const ManualPart = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem
`

// text input

const TextFieldStyled = styled.div`
  .bx--text-input, .bx--dropdown, .bx--text-area {
    background-color: ${({ isDirty }) => isDirty && `#e6f7ff !important`};
  }
`
const TrashCan = styled.div`
  i {
    // color: red;
    :hover {
      cursor: pointer;
      color: #ed1201;
    }
    // float: right;
  }
`

const FileUploadStyled = styled.div`
  background-color: #f4f4f4;
  padding: 1rem;

  .bx--file--label {
    letter-spacing: 0.32px;
    display: inline-block;
    margin-bottom: 0.5rem;
    color: #525252;
    font-weight: 400;
    line-height: 1rem;
  }

  // button
  .bx--btn--ghost {
    color: black;
    border: 1px solid #8d8d8d;
    border-radius: 5px;
    background-color: #d9d9d9;
  }

  .bx--btn--ghost:hover, .bx--btn--ghost:active {
    color: #0f62fe;
    border-color: #0f62fe;
  }

  .bx--file-container {
    width: 100%;
  }

  .bx--file__selected-file {
    border-bottom: 1px dotted black;
    color: black;
    max-width: inherit;
    background-color: ${({ isDirty }) => isDirty && `#e6f7ff`};
  }

  img {
    width: 100%;
  }
`

const OverrideCardStyled = styled.div`
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}
`